"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSocketListener = exports.processSocketEvent = exports.configureSocket = exports.addSocketListener = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _immutable = require("immutable");

var _v = _interopRequireDefault(require("uuid/v4"));

var _events = require("./events");

var _meta = require("./meta");

var _socket = require("./socket");

var _state = require("./state");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var listeners = new _immutable.Map();

var SocketManager =
/*#__PURE__*/
function () {
  function SocketManager() {
    _classCallCheck(this, SocketManager);

    this.socket = null;
    this.onAuthorise = this.onAuthorise.bind(this);
    this.onConnect = this.onConnect.bind(this);
    this.onDisconnect = this.onDisconnect.bind(this);
    this.onSignOut = this.onSignOut.bind(this);
    this.onChangedMobile = this.onChangedMobile.bind(this);
    this.onChangedWeb = this.onChangedWeb.bind(this);
    this.onChangedDashboards = this.onChangedDashboards.bind(this);
    this.onDashboardInvitation = this.onDashboardInvitation.bind(this);
    this.onGroupsChanged = this.onGroupsChanged.bind(this);
  }

  _createClass(SocketManager, [{
    key: "addHooks",
    value: function addHooks() {
      if (!this.socket) return;
      this.socket.on(_events.WS_AUTHORISE, this.onAuthorise);
      this.socket.on(_events.WS_CONNECT, this.onConnect);
      this.socket.on(_events.WS_DISCONNECT, this.onDisconnect);
      this.socket.on(_events.WS_SIGNOUT, this.onSignOut);
      this.socket.on(_events.WS_CHANGED_MOBILE, this.onChangedMobile);
      this.socket.on(_events.WS_CHANGED_WEB, this.onChangedWeb);
      this.socket.on(_events.WS_CHANGED_DASHBOARDS, this.onChangedDashboards);
      this.socket.on(_events.WS_CHANGED_DASHBOARDS_WEB, this.onChangedDashboards);
      this.socket.on(_events.WS_CHANGED_DASHBOARDS_MOBILE, this.onChangedDashboards);
      this.socket.on(_events.WS_ADD_INVITATION, this.onDashboardInvitation);
      this.socket.on(_events.WS_GROUPS_CHANGED, this.onGroupsChanged);
    }
  }, {
    key: "broadcastEvent",
    value: function broadcastEvent(event, data) {
      listeners.valueSeq().forEach(function (callback) {
        return callback(event, data);
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (!this.socket) return;
      this.socket.disconnect();
      this.removeHooks();
    }
  }, {
    key: "getSocket",
    value: function () {
      var _getSocket2 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.socket) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return (0, _socket.getSocket)();

              case 3:
                this.socket = _context.sent;
                this.addHooks();

              case 5:
                return _context.abrupt("return", this.socket);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSocket() {
        return _getSocket2.apply(this, arguments);
      }

      return getSocket;
    }()
  }, {
    key: "getSocketId",
    value: function getSocketId() {
      return (0, _meta.getSocketId)(this.socket);
    }
  }, {
    key: "isConnected",
    value: function isConnected() {
      return (0, _meta.isSocketConnected)(this.socket);
    }
  }, {
    key: "isMock",
    value: function isMock() {
      return !!this.socket.mock;
    }
  }, {
    key: "onAuthorise",
    value: function onAuthorise(data) {
      this.broadcastEvent(_events.WS_AUTHORISE, data);
      var socketId = (0, _meta.getSocketId)(this.socket);
      this.socket.subscribe("presence-".concat(socketId));
    }
  }, {
    key: "onConnect",
    value: function onConnect(data) {
      this.broadcastEvent(_events.WS_CONNECT, data);
    }
  }, {
    key: "onDisconnect",
    value: function onDisconnect(data) {
      this.broadcastEvent(_events.WS_DISCONNECT, data);
    }
  }, {
    key: "onSignOut",
    value: function onSignOut(data) {
      this.broadcastEvent(_events.WS_SIGNOUT, data);
    }
  }, {
    key: "onChangedMobile",
    value: function onChangedMobile(data) {
      this.broadcastEvent(_events.WS_CHANGED_MOBILE, data);
    }
  }, {
    key: "onChangedWeb",
    value: function onChangedWeb(data) {
      this.broadcastEvent(_events.WS_CHANGED_WEB, data);
    }
  }, {
    key: "onDashboardInvitation",
    value: function onDashboardInvitation(data) {
      this.broadcastEvent(_events.WS_ADD_INVITATION, data);
    }
  }, {
    key: "onGroupsChanged",
    value: function onGroupsChanged(data) {
      this.broadcastEvent(_events.WS_GROUPS_CHANGED, data);
    }
  }, {
    key: "onChangedDashboards",
    value: function onChangedDashboards(data) {
      this.broadcastEvent(_events.WS_CHANGED_DASHBOARDS, data);
    }
  }, {
    key: "removeHooks",
    value: function removeHooks() {
      if (!this.socket) return;
      this.socket.removeListener(_events.WS_AUTHORISE, this.onAuthorise);
      this.socket.removeListener(_events.WS_CONNECT, this.onConnect);
      this.socket.removeListener(_events.WS_DISCONNECT, this.onDisconnect);
      this.socket.removeListener(_events.WS_SIGNOUT, this.onSignOut);
      this.socket.removeListener(_events.WS_CHANGED_MOBILE, this.onChangedMobile);
      this.socket.removeListener(_events.WS_CHANGED_WEB, this.onChangedWeb);
      this.socket.removeListener(_events.WS_ADD_INVITATION, this.onDashboardInvitation);
      this.socket.removeListener(_events.WS_GROUPS_CHANGED, this.onGroupsChanged);
      this.socket.removeListener(_events.WS_CHANGED_DASHBOARDS, this.onChangedDashboards);
      this.socket.removeListener(_events.WS_CHANGED_DASHBOARDS_WEB, this.onChangedDashboards);
      this.socket.removeListener(_events.WS_CHANGED_DASHBOARDS_MOBILE, this.onChangedDashboards);
      this.socket = null;
    }
  }, {
    key: "requireSocket",
    value: function () {
      var _requireSocket = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getSocket();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function requireSocket() {
        return _requireSocket.apply(this, arguments);
      }

      return requireSocket;
    }()
  }, {
    key: "subscribeChannel",
    value: function subscribeChannel(data) {
      (0, _state.setState)({
        authToken: data
      });
      var socketId = (0, _meta.getSocketId)(this.socket);
      var channelName = "presence-".concat(socketId);
      this.socket.subscribe(channelName);
    }
  }]);

  return SocketManager;
}();

var manager = new SocketManager();

var addSocketListener = function addSocketListener(callback) {
  var id = (0, _v.default)();
  listeners = listeners.set(id, callback);
  return id;
};

exports.addSocketListener = addSocketListener;

var configureSocket = function configureSocket() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var debug = args.debug,
      environment = args.environment,
      mock = args.mock;
  var connectionDelay = 0;
  (0, _socket.configureSocket)(environment, mock, debug, connectionDelay);
};

exports.configureSocket = configureSocket;

var processSocketEvent =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3() {
    var payload,
        res,
        _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
            _context3.t0 = payload.event;
            _context3.next = _context3.t0 === _events.SM_DISCONNECT ? 4 : _context3.t0 === _events.SM_GET_ID ? 7 : _context3.t0 === _events.SM_GET_SOCKET ? 10 : _context3.t0 === _events.SM_IS_CONNECTED ? 13 : _context3.t0 === _events.SM_IS_MOCK ? 16 : _context3.t0 === _events.SM_REQUIRE_SOCKET ? 19 : 22;
            break;

          case 4:
            _context3.next = 6;
            return manager.disconnect();

          case 6:
            return _context3.abrupt("return", res = _context3.sent);

          case 7:
            _context3.next = 9;
            return manager.getSocketId();

          case 9:
            return _context3.abrupt("return", res = _context3.sent);

          case 10:
            _context3.next = 12;
            return manager.getSocket();

          case 12:
            return _context3.abrupt("return", res = _context3.sent);

          case 13:
            _context3.next = 15;
            return manager.isConnected();

          case 15:
            return _context3.abrupt("return", res = _context3.sent);

          case 16:
            _context3.next = 18;
            return manager.isMock();

          case 18:
            return _context3.abrupt("return", res = _context3.sent);

          case 19:
            _context3.next = 21;
            return manager.requireSocket();

          case 21:
            return _context3.abrupt("return", res = _context3.sent);

          case 22:
            return _context3.abrupt("return", res);

          case 23:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function processSocketEvent() {
    return _ref.apply(this, arguments);
  };
}();

exports.processSocketEvent = processSocketEvent;

var removeSocketListener = function removeSocketListener(id) {
  listeners = listeners.delete(id);
};

exports.removeSocketListener = removeSocketListener;